import { useLang } from "@/context/LanguageContext";
import { ScrollText } from "lucide-react";

const Row = ({ label, value }) =>
  value ? (
    <div className="flex flex-col gap-1 border-b border-line py-3 sm:flex-row sm:gap-6">
      <span className="w-full shrink-0 text-xs uppercase tracking-[0.16em] text-ink-3 sm:w-48">{label}</span>
      <span className="tg-note text-sm leading-relaxed text-ink-2">{value}</span>
    </div>
  ) : null;

export default function SourcesBlock({ item }) {
  const { t } = useLang();
  // Unify Scriptural Reference + Textual Reference + References into one section
  // so references appear consistently (one label) across every article.
  const scriptural = [
    item.scriptural_reference,
    item.textual_reference,
    item.references && item.references.length ? item.references.join("; ") : "",
  ].filter(Boolean).join(" · ");

  const hasAny = item.source || scriptural || item.regional_tradition || item.editorial_note;

  if (!hasAny) return null;

  return (
    <section data-testid="sources-block" className="mt-14 border border-line bg-[var(--surface-alt)]/40 p-6 md:p-8">
      <div className="mb-4 flex items-center gap-2">
        <ScrollText className="h-4 w-4 text-gold" />
        <h3 className="overline-label text-ink-3">{t("sources")}</h3>
      </div>
      <div>
        <Row label="Source / Tradition" value={item.source} />
        <Row label="Scriptural References" value={scriptural} />
        <Row label="Regional Tradition" value={item.regional_tradition} />
        {item.editorial_note && <Row label="Editorial Note" value={item.editorial_note} />}
      </div>
      <p className="mt-5 tg-note text-xs italic leading-relaxed text-ink-3">
        Dharmartha presents traditional knowledge with respect for its sources. Practices vary by
        lineage and region; this material does not assert exclusive or universal authority.
      </p>
    </section>
  );
}
